import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { CmdToastButton } from '@commander-services/gui-components/build/components/CmdToast/CmdToast';
import { isBluecoinsOpenAtom, selectedBluecoinsAtom } from '../Bluecoins/BluecoinState';
import ConfirmToaster from '../../Forms/ConfirmToaster/ConfirmToaster';
import {
  isDrawWaypointAtom,
  isEditModeAtom,
  isMinimalizedWpAtom,
  isWaypointsOpenAtom,
} from '../Waypoints/WaypointState';
import { isAllSimpleWindowsOpenAtom } from '../OnlineMapState';
import useAnalytics from '../../../hooks/useAnalytics';

export default function WaypointsControl() {
  const { formatMessage: f } = useIntl();
  const [isBluecoinsOpen, setIsBluecoinsOpen] = useRecoilState<boolean>(isBluecoinsOpenAtom);
  const [isWaypointsOpen, setIsWaypointsOpen] = useRecoilState(isWaypointsOpenAtom);
  const setIsAllSimpleWindowsOpen = useSetRecoilState<boolean>(isAllSimpleWindowsOpenAtom);
  const setIsEditMode = useSetRecoilState<boolean>(isEditModeAtom);
  const setIsDrawWaypoint = useSetRecoilState<boolean>(isDrawWaypointAtom);
  const [isMinimalizedWp, setIsMinimalized] = useRecoilState<boolean>(isMinimalizedWpAtom);
  const [isConfirmDialogClosed, setIsConfirmDialogClosed] = React.useState(false);
  const setSelectedBluecoins = useSetRecoilState(selectedBluecoinsAtom);
  const { trackEvent } = useAnalytics();

  const handleOpenWaypoints = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    event.preventDefault();
    trackEvent(['map', 'click', 'Click waypoint icon on map']);
    if (isBluecoinsOpen) {
      setIsConfirmDialogClosed(true);
      return;
    }
    setIsBluecoinsOpen(false);
    setSelectedBluecoins([]);
    // setIsDrawWaypoint(false);
    // setIsEditMode(false);

    if (isWaypointsOpen && !isMinimalizedWp) {
      setIsWaypointsOpen(false);
      setIsAllSimpleWindowsOpen(false);
      setIsMinimalized(false);
      setIsDrawWaypoint(false);
      setIsEditMode(false);
    } else if (isWaypointsOpen && isMinimalizedWp) {
      // setIsWaypointsOpen(false);
      setIsAllSimpleWindowsOpen(false);
      setIsMinimalized(false);
    } else {
      setIsDrawWaypoint(false);
      setIsEditMode(false);
      setIsWaypointsOpen(true);
      setIsAllSimpleWindowsOpen(false);
      setIsMinimalized(false);
    }
  };

  const handleWpClassName = () => {
    if (isWaypointsOpen && !isMinimalizedWp) {
      return 'e-button-sq text-primary';
    }

    if (isWaypointsOpen && isMinimalizedWp) {
      return 'e-button-sq bubble-on';
    }

    return 'e-button-sq';
  };

  const handleClose = (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent> | KeyboardEvent) => {
    if (event) event.preventDefault();
    setIsConfirmDialogClosed(false);
  };

  const handleConfirmDialog = (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (event) {
      event.preventDefault();
      setIsBluecoinsOpen(false);
      setSelectedBluecoins([]);

      if (isWaypointsOpen && !isMinimalizedWp) {
        setIsWaypointsOpen(false);
        setIsAllSimpleWindowsOpen(false);
        setIsMinimalized(false);
        setIsDrawWaypoint(false);
        setIsEditMode(false);
      } else if (isWaypointsOpen && isMinimalizedWp) {
        // setIsWaypointsOpen(false);
        setIsAllSimpleWindowsOpen(false);
        setIsMinimalized(false);
      } else {
        setIsDrawWaypoint(false);
        setIsEditMode(false);
        setIsWaypointsOpen(true);
        setIsAllSimpleWindowsOpen(false);
        setIsMinimalized(false);
      }
    }

    setIsConfirmDialogClosed(false);
  };
  const buttons: CmdToastButton[] = [
    {
      title: f({
        id: 'form.cancel',
      }),
      style: 'link',
      type: 'cancel',
      onClickCallback: handleClose,
    },
    {
      title: f({ id: 'map.bluecoins.toast.confirmBtn' }),
      style: 'solid',
      type: 'confirm',
      onClickCallback: handleConfirmDialog,
    },
  ];

  return (
    <>
      {isConfirmDialogClosed && (
        <ConfirmToaster
          id="waypointToast"
          title={f({ id: 'map.bluecoins.toast.warningTitle' })}
          message={f({ id: 'map.bluecoins.toast.warningMessage' })}
          type="warning"
          duration={null}
          onClose={handleClose}
          buttons={buttons}
        />
      )}

      <a
        onClick={handleOpenWaypoints}
        title={f({ id: 'enum.area.tab.title' })}
        data-cy="controls-on-map-waypoints"
        className={handleWpClassName()}
        // className={` ${
        //   isWaypointsOpen
        //     ? `e-button-sq text-primary`
        //     : `e-button-sq ${filteredWaypointsString.length > 0 && 'bubble-on'}`
        // }`}
      >
        <i className="cmd-icons cmd-icon-waypoint" />
      </a>
    </>
  );
}
